module.exports = __webpack_public_path__ + "assets/passive-rosette.226f6a5c.svg";